import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, renderList as _renderList, normalizeClass as _normalizeClass, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, vModelRadio as _vModelRadio, withCtx as _withCtx } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "wf-waiting-status"
};
const _hoisted_2 = {
    key: 1,
    class: "wf-options wf-undo-controls"
};
const _hoisted_3 = {
    key: 2,
    class: "wf-root"
};
const _hoisted_4 = { for: "suspend-checkbox" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = {
    key: 3,
    class: "wf-options wf-undo-controls"
};
const _hoisted_7 = {
    key: 0,
    class: "form-radio"
};
const _hoisted_8 = ["name"];
const _hoisted_9 = {
    key: 1,
    class: "form-radio"
};
const _hoisted_10 = ["name"];
const _hoisted_11 = {
    key: 2,
    style: { "margin": "5px 30px 10px" },
    class: "wf-action"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_PresentationHost = _resolveComponent("PresentationHost");
    const _component_AppButton = _resolveComponent("AppButton");
    const _component_PlayerInputFactory = _resolveComponent("PlayerInputFactory");
    const _component_InputPortal = _resolveComponent("InputPortal");
    const _directive_i18n = _resolveDirective("i18n");
    return (_openBlock(), _createElementBlock("div", null, [
        (_ctx.waitingPresentation !== undefined && _ctx.presentationBinding !== undefined)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.waitingPresentation), {
                key: 0,
                binding: _ctx.presentationBinding
            }, null, 8, ["binding"]))
            : (_openBlock(), _createBlock(_component_PresentationHost, {
                key: 1,
                hosts: _ctx.bodyHost
            }, null, 8, ["hosts"])),
        _createVNode(_component_InputPortal, {
            target: _ctx.bodyHost.target.value
        }, {
            default: _withCtx(() => [
                (_ctx.waitingfor === undefined || _ctx.waitingfor.optional)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_ctx.waitingfor === undefined)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('Not your turn to take any actions')), 1)
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('Waiting for other players')), 1)
                            ], 64)),
                        (_ctx.playersWaitingFor.length > 0)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _cache[4] || (_cache[4] = _createTextVNode(" (⌛ ", -1)),
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.playersWaitingFor, (color) => {
                                    return (_openBlock(), _createElementBlock("span", {
                                        class: _normalizeClass(["log-player", _ctx.playerColorClass(color, 'bg')]),
                                        key: color
                                    }, _toDisplayString(_ctx.getPlayerName(color)), 3));
                                }), 128)),
                                _cache[5] || (_cache[5] = _createTextVNode(") ", -1))
                            ], 64))
                            : _createCommentVNode("", true)
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.showResearchPurchaseUndo())
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_AppButton, {
                            title: "Undo card purchase (experimental)",
                            type: "submit",
                            size: "normal",
                            onClick: _ctx.undoResearchPurchase
                        }, null, 8, ["onClick"])
                    ], 512)), [
                        [_vShow, _ctx.waitingPresentation === undefined || _ctx.presentationBinding === undefined]
                    ])
                    : _createCommentVNode("", true),
                (_ctx.waitingfor !== undefined)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        (_ctx.preferences().experimental_ui && _ctx.playerView.game.phase === _ctx.Phase.ACTION)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _withDirectives(_createElementVNode("input", {
                                    type: "checkbox",
                                    name: "suspend",
                                    id: "suspend-checkbox",
                                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.suspend) = $event)),
                                    onChange: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.updateSuspend && _ctx.updateSuspend(...args)))
                                }, null, 544), [
                                    [_vModelCheckbox, _ctx.suspend]
                                ]),
                                _createElementVNode("label", _hoisted_4, [
                                    _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[6] || (_cache[6] = [
                                            _createTextVNode("Pause updates", -1)
                                        ]))])), [
                                        [_directive_i18n]
                                    ])
                                ]),
                                (_ctx.showRefresh())
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[7] || (_cache[7] = [
                                            _createTextVNode("Refresh", -1),
                                            _createElementVNode("span", { class: "reset" }, null, -1)
                                        ]))]))
                                    : _createCommentVNode("", true)
                            ], 64))
                            : _createCommentVNode("", true),
                        _createVNode(_component_PlayerInputFactory, {
                            players: _ctx.playerView.players,
                            playerView: _ctx.playerView,
                            playerinput: _ctx.playerinputWithStepBack(),
                            onsave: _ctx.onsavePlayerInput,
                            showsave: true,
                            showtitle: true
                        }, null, 8, ["players", "playerView", "playerinput", "onsave"])
                    ]))
                    : _createCommentVNode("", true),
                (_ctx.showUndoFooter())
                    ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
                        (_ctx.showUndoAction())
                            ? (_openBlock(), _createElementBlock("label", _hoisted_7, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.undoChoice) = $event)),
                                    type: "radio",
                                    name: _ctx.undoRadioElementName,
                                    value: "action"
                                }, null, 8, _hoisted_8), [
                                    [_vModelRadio, _ctx.undoChoice]
                                ]),
                                _cache[9] || (_cache[9] = _createElementVNode("i", { class: "form-icon" }, null, -1)),
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[8] || (_cache[8] = [
                                        _createTextVNode("Undo action", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.showStepBack())
                            ? (_openBlock(), _createElementBlock("label", _hoisted_9, [
                                _withDirectives(_createElementVNode("input", {
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.undoChoice) = $event)),
                                    type: "radio",
                                    name: _ctx.undoRadioElementName,
                                    value: "step"
                                }, null, 8, _hoisted_10), [
                                    [_vModelRadio, _ctx.undoChoice]
                                ]),
                                _cache[11] || (_cache[11] = _createElementVNode("i", { class: "form-icon" }, null, -1)),
                                _withDirectives((_openBlock(), _createElementBlock("span", null, [...(_cache[10] || (_cache[10] = [
                                        _createTextVNode("Undo one step (experimental)", -1)
                                    ]))])), [
                                    [_directive_i18n]
                                ])
                            ]))
                            : _createCommentVNode("", true),
                        (_ctx.undoChoice)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                _createVNode(_component_AppButton, {
                                    title: "Undo",
                                    type: "submit",
                                    size: "normal",
                                    onClick: _ctx.undoSelected
                                }, null, 8, ["onClick"])
                            ]))
                            : _createCommentVNode("", true)
                    ], 512)), [
                        [_vShow, _ctx.waitingPresentation === undefined || _ctx.presentationBinding === undefined]
                    ])
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }, 8, ["target"])
    ]));
}
